module.exports = {
      id: "twitter-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#twitter",
      toString: function () {
        return this.url;
      }
    }